import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation deleteKitDevice($id: String!) {
    deleteKitDevice(id: $id) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const deleteKitDeviceRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'kit_device/delete_kit_device',
  async (params: {id: String;}, { extra: client }) => {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.deleteKitDevice;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const deleteKitDeviceSlice = createSlice({
  name: 'delete_kit_device',
  initialState: initialState,
  reducers: {
    deleteKitDeviceClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(deleteKitDeviceRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(deleteKitDeviceRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(deleteKitDeviceRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { deleteKitDeviceClear } = deleteKitDeviceSlice.actions;

export const deleteKitDevice = createSelector(
  (state: RootState) => state.kitDevice.deleteKitDevice.result,
  (state: RootState) => state.kitDevice.deleteKitDevice.error,
  (state: RootState) => state.kitDevice.deleteKitDevice.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default deleteKitDeviceSlice.reducer;